import React from "react";

export default function CloseEye() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 60 60"
      fill="none"
    >
      <g clipPath="url(#clip0_176_2)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M60 60H48.75L40.638 50.016C37.3683 51.6307 33.7347 52.5 30 52.5C22.8716 52.5 16.1114 49.3339 11.5479 43.8574L0 30L11.5479 16.1425C11.8121 15.8255 12.0836 15.5163 12.3621 15.2149L0 0H11.25L60 60ZM20.072 24.704C19.2283 26.2823 18.75 28.0853 18.75 30C18.75 36.2132 23.7868 41.25 30 41.25C31.0942 41.25 32.1519 41.0936 33.152 40.8026L20.072 24.704Z"
          fill="gray"
        />
        <path
          d="M59.9993 30L53.3536 37.9748L28.625 7.5393C29.0813 7.51316 29.5395 7.5 29.9993 7.5C37.1277 7.5 43.8878 10.6663 48.4516 16.1425L59.9993 30Z"
          fill="gray"
        />
      </g>
      <defs>
        <clipPath id="clip0_176_2">
          <rect width="60" height="60" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
